export const FALLBACK_PRODUCT_NOTE_TEMPLATES = [
  { key: 'popcorn', label: 'Popcorn', text: 'This product is for a popcorn dealer, remove CBG products in favor of C and or BG' },
  { key: 'upgrade', label: 'Upgrade', text: 'Remove the lower product package in favor of higher package' },
  { key: 'downgrade', label: 'Downgrade', text: 'Remove the higher package in favor of lower' },
  { key: 'update_dpe', label: 'Update DPE', text: 'DPE has been updated to reflect this product' },
  { key: 'sec_mismatch', label: 'SEC mismatch', text: 'Applied a Secondary package price to a primary dealer' },
  { key: 'duplicate_product', label: 'Duplicate Product', text: 'Remove this product from file as a duplicate product' },
  { key: 'added_in_error', label: 'Added in error', text: 'This product was added to this account in error, and should be removed' },
];
